export const inboxBriefingMorningCommandText = "A8wpvb";
export const inboxBriefingEveningCommandText = "sYBY$b";
export default {inboxBriefingMorningCommandText,inboxBriefingEveningCommandText};